module.exports = __webpack_public_path__ + "media/images/step_optimisation_en-3ed0350d236212f997cb160cb9512380.svg";